import MerchantPendingApprovalPage from '../../../../components/merchant/pending-approval/MerchantPendingApprovalPage'

export default function PendingApproval() {
  return <MerchantPendingApprovalPage />
}
